import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import useToken from '../hooks/useToken';
import { SanitizedHTML } from '../utils/Helper';
import { API_ENDPOINTS } from '../utils/config';

const RelatedPosts = ({ data: postId }) => {
    const [relatedPosts, setRelatedPosts] = useState([]);
    const { token } = useToken();

    const fetchRelatedPosts = useCallback(async () => {
        if (!postId) return;

        try {
            const { data, status } = await axios.get(
                `${API_ENDPOINTS.RELARED_POST_ENDPOINT}/${postId}`,
                {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (status === 200 && Array.isArray(data?.items)) {
                setRelatedPosts(data.items);
            } else if (status === 401) {
                console.warn('Unauthorized access');
                setRelatedPosts([]);
            }

        } catch (error) {
            console.error('Error fetching related posts:', error);
        }
    }, [postId, token]);

    useEffect(() => {
        fetchRelatedPosts();
    }, [fetchRelatedPosts]);

    const renderCategories = (categories) => (
        <span className="post-category">
            {categories.map(({ slug, name }, idx) => (
                <Link
                    to={`/categories/${slug}`}
                    key={idx}
                    className="text-muted text-decoration-none p-1"
                >
                    {name}
                </Link>
            ))}
        </span>
    );

    const renderPostItem = (post, idx) => {
        const {
            post_author_url: authorImage,
            post_author_name: authorName,
            title,
            slug,
            categories,
        } = post;

        return (
            <li key={idx}>
                <div className="post-wrapper d-flex align-center text-2 align-items-center position-relative">
                    {authorImage && (
                        <span className="post-author">
                            <Link to="/about-me" className="text-muted d-flex align-center">
                                <img
                                    src={authorImage}
                                    alt={authorName || 'Author'}
                                    className="img-fluid rounded-circle"
                                />
                            </Link>
                        </span>
                    )}
                    {categories && renderCategories(categories)}
                    <h3 className="fw-500 text-3 text-start">
                        <Link to={`/blog/${slug}`}>
                            <SanitizedHTML html={title} tag="span" />
                        </Link>
                    </h3>
                </div>
            </li>
        );
    };

    return (
        Array.isArray(relatedPosts) && relatedPosts.length > 0 && (
            <div className="related-posts-wrapper mt-5">
                <h3 className="pb-4">Read Also:</h3>
                <ul className="d-flex align-items-start flex-wrap p-0 m-0">
                    {relatedPosts.map(renderPostItem)}
                </ul>
            </div>
        )
    );
};

RelatedPosts.propTypes = {
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default RelatedPosts;
